import $ from "jquery";
import 'moment-timezone';
import React, { useState, useEffect, useContext, forwardRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import SessionManager from "../../routes/SessionManager";
import bootbox from 'bootbox';
import Toastr from 'toastr';
import Loading from "../Loading";
import no_image from './../../assets/img/no-image.png';
import LZString from 'lz-string';
import CommonUtils from "../../util/CommonUtils";
import { Select } from "antd";
import { Context } from "../../views/app";
import API from '../../service/SiteKickAPIService';

let bounds = new Array(400).fill(0);

function VehicleTracking(props, refs) {

    const appContext = useContext(Context);
    let user = appContext.user;
    let defaultZone = null;
    let saving;
    if (user.zones && user.zones.length > 0) {
        defaultZone = (user.zone_selected && user.zones.find(z => z.location_id === user.zone_selected.location_id)) ? user.zone_selected : Object.values(user.zones)[0];
    }
    const [tracking_type, setTrackingType] = useState('motion_detection');
    const [zones, setZones] = useState(user.zones);
    const [zone_selected, setZoneSelected] = useState(defaultZone);
    const [modified, setModified] = useState(false);
    const [selectedZone, setSelectedZone] = useState(defaultZone);
    const [latest_image, setLatestImage] = useState({});
    const [currentZone, setCurrentZone] = useState(undefined);
    const [capture, setCapture] = useState(false);
    const [timeout, setTimeOut] = useState(null);
    const [isZoneModified, setIsZoneModified] = useState(false);
    const [isTrackingModified, setIsTrackingModified] = useState(false);

    let tracking_types = [{ value: 'motion_detection', label: 'Object Detection' }, { value: 'vtracking', label: 'Vehicle Tracking' }];

    CanvasRenderingContext2D.prototype.clear = CanvasRenderingContext2D.prototype.clear || function (preserveTransform) {
        if (preserveTransform) {
            this.save();
            this.setTransform(1, 0, 0, 1, 0, 0);
        }
        this.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (preserveTransform) {
            this.restore();
        }
    };

    useEffect(() => {
        if (window.location.search && window.location.search.indexOf('fetchLatestImage') !== -1) {
            fetchLatestImage();
        }
    }, []);

    const fetchLatestImage = () => {
        CommonUtils.ajax(
            {
                url: API.AXIS_CAMERA.LATEST_IMAGE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify({
                    device_id: zone_selected.device_id,
                    location_id: zone_selected.location_id,
                    site_id: zone_selected.site_id,
                    customer_id: zone_selected.customer_id,
                })
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    setLatestImage({ ...latest_image, [zone_selected.location_id]: res.data });
                    drawTrackingPolygon();
                }
            },
            (res) => {

            });
    }

    const makeZoneSelection = (z) => {
        if (zone_selected && modified && zone_selected.location_id !== z.location_id) {
            bootbox.confirm({
                message: 'Would you like to save zone settings before you move on ?', buttons: {
                    confirm: {
                        label: 'Yes, Please ...'
                    },
                    cancel: {
                        label: 'No'
                    }
                }, callback: (isYes) => {
                    if (isYes) {
                        $('.save-vh-settings').trigger('click');
                    } else {
                        let bound = new Array(400).fill(0);
                        bounds = bound;
                        cancelTrackingConfig();
                        setZoneSelected(JSON.parse(JSON.stringify(z)));
                        setSelectedZone(JSON.parse(JSON.stringify(z)));
                        isModified(true);
                    }
                }
            });
        } else if (!modified) {
            let bound = new Array(400).fill(0);
            bounds = bound;
            setIsZoneModified(true);
            setZoneSelected(JSON.parse(JSON.stringify(z)));
            setSelectedZone(JSON.parse(JSON.stringify(z)));
        }
    }

    useEffect(() => {
        if (zone_selected !== user.zone_selected) {
            setTimeout(createMesh, 300);
            drawTrackingPolygon();
        }
    }, [zone_selected]);

    const createMesh = () => {
        if ($('#grid').length === 0)
            return;

        $('#grid').on('mousedown', () => { setCapture(true) });
        $('#grid').on('mouseup', () => { setCapture(false) });

        let image_wh = [$('#track_vehicle_image').width(), $('#track_vehicle_image').height()];
        let box_wh = [(((image_wh[0] - 1) / 20) - 1), (((image_wh[1] - 1) / 20) - 1)]
        $('#grid')[0].style.display = 'flex';
        $('#grid')[0].style.flexWrap = 'wrap';

        $('#grid').width(image_wh[0] + "px");
        $('#grid').height(image_wh[1] + "px");

        $('.optedCell').width(box_wh[0] + 'px');
        $('.optedCell').height(box_wh[1] + 'px');

        $('#zonesContainer').attr('style', 'max-height:' + (image_wh[1] < 100 ? 300 : image_wh[1]) + 'px !important; overflow-y: scroll');
        if (!currentZone || currentZone !== zone_selected.location_id) {
            setCurrentZone(zone_selected.location_id);
        }
    }

    useEffect(() => {
        applyTracking();
    }, [currentZone]);

    const applyTracking = () => {
        try {
            let tracking = zone_selected.location_config.feature_controls[tracking_type];
            if (tracking && tracking.motion_frames) {
                let bound = tracking.motion_frames.mask_data ? JSON.parse(LZString.decompressFromBase64(tracking.motion_frames.mask_data)) : new Array(400).fill(0);
                for (let i = 0; i < bound.length; i++) {
                    if (bound[i] === 1)
                        $('#opted-cell-' + i).addClass('optedCellHighlighted');
                }
                bounds = bound;
            }
            toggleClearMaskButton();
        } catch (e) { }
    }

    const toggleClearMaskButton = () => {
        if (bounds.includes(1))
            setTimeout(() => {
                $('#clear_bounds_btn').removeClass('invisible')
            }, 100);
        else
            setTimeout(() => {
                $('#clear_bounds_btn').addClass('invisible')
            }, 100);
    }

    const changeTrackingCategory = (v) => {
        if (modified) {
            bootbox.confirm('Would you like to save tracking configuration ?', (isYes) => {
                if (!isYes) {
                    setTrackingType(v);
                } else {
                    saveTrackingConfig();
                }
            });
        } else {
            setTrackingType(v);
            setIsTrackingModified(true);
        }
    }

    useEffect(() => {
        if (isTrackingModified) {
            cancelTrackingConfig();
            drawTrackingPolygon();
        }
    }, [tracking_type]);

    const publishTrackingConfig = (device_id, location_config) => {
        CommonUtils.ajax(
            {
                url: API.AXIS_CAMERA.PUBLISH_TRACKING_CONFIG,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify({
                    device_id: device_id,
                    tracking_config: {
                        vtracking: location_config.feature_controls['vtracking'],
                        motion_detection: location_config.feature_controls['motion_detection']
                    }
                }),
            }
        ).then((res) => {
            if (res.status.code === 200) {
                drawTrackingPolygon();
                let x = res.data.data.axis_mask.opt_contour_points;
                let prev = null;
                $('#grid_canvas').css('width', '914px');
                $('#grid_canvas').css('height', '518px');
                $('#grid_canvas').css('left', '0px');

                clearCanvas();
                for (let j = 0; j < x.length; j++) {
                    let data = x[j];
                    for (let i = 1; i < data.length; i++) {
                        if (!prev)
                            prev = data[0];

                        //console.log(prev, data[i])
                        draw(prev, data[i]);
                        prev = data[i];
                    }
                    prev = null;
                    draw(data[0], data[data.length - 1]);
                }
            } else {
                Toastr.error('Error occurred while saving Zone tracking configuration');
            }
        }, (err) => {
            Toastr.error('Error occurred while saving Zone tracking configuration');
        });
    }

    const getAxisMasks = (device_id, location_config) => {
        CommonUtils.ajax(
            {
                url: API.AXIS_CAMERA.AXIS_MASKS,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify({
                    device_id: device_id,
                    tracking_config: {
                        tracking_type: tracking_type,
                        [tracking_type]: location_config.feature_controls[tracking_type],
                    }
                }),
            }
        ).then((res) => {
            if (res.status.code === 200) {
                clearCanvas();
                let x = res.data.data.axis_mask.opt_contour_points;
                let prev = null;
                $('#grid_canvas').css('width', $('#grid').css('width'));
                $('#grid_canvas').css('height', $('#grid').css('height'));
                $('#grid_canvas').css('left', '0px');
                for (let j = 0; j < x.length; j++) {
                    let data = x[j];
                    for (let i = 1; i < data.length; i++) {
                        if (!prev)
                            prev = data[0];

                        //console.log(prev, data[i])
                        draw(prev, data[i]);
                        prev = data[i];
                    }
                    prev = null;
                    draw(data[0], data[data.length - 1]);
                }
            } else {
            }
        }, (err) => {
        });
    }

    const postTrackingChange = () => {
        let location = JSON.parse(JSON.stringify(zone_selected));
        let defaultTracking = {
            enabled: false,
            motion_frames: []
        };

        if (location.location_config) {
            delete location.location_config[tracking_type];
            if (location.location_config.feature_controls === undefined)
                location.location_config.feature_controls = {};

            if (location.location_config.feature_controls[tracking_type]) {
                for (let k in defaultTracking) {
                    if (location.location_config.feature_controls[tracking_type][k] === undefined) {
                        location.location_config.feature_controls[tracking_type][k] = defaultTracking[k];
                    }
                }
            } else {
                location.location_config.feature_controls[tracking_type] = { ...defaultTracking };
            }
        } else {
            location.location_config = { feature_controls: {}, config_version: 0 };
            location.location_config.feature_controls = {
                [tracking_type]: {
                    enabled: false,
                    motion_frames: []
                }
            };
        }

        let motion_frames = {
            "mask_geometry": {
                "height": 20,  // height - number of rows of boxes 
                "width": 20    // width - number of boxes in the row
            },
            mask_data: bounds
        };

        motion_frames.mask_data = LZString.compressToBase64(JSON.stringify(motion_frames.mask_data));
        location.location_config.feature_controls[tracking_type].motion_frames = motion_frames;
        if (tracking_type === 'vtracking')
            location.location_config.feature_controls.vtracking.className = ["truck", "car"];

        getAxisMasks(zone_selected.device_id, location.location_config);
    }

    const saveTrackingConfig = () => {
        let location = zone_selected;
        let defaultTracking = {
            enabled: tracking_type === 'vtracking' ? false : true,
            motion_frames: {}
        };

        let bound = LZString.compressToBase64(JSON.stringify(new Array(400).fill(0)));
        let tracking = [{
            enabled: true,
            motion_frames: {
                "mask_geometry": {
                    "height": 20,  // height - number of rows of boxes 
                    "width": 20    // width - number of boxes in the row
                },
                mask_data: bound
            }
        }, {
            enabled: false,
            motion_frames: {
                "mask_geometry": {
                    "height": 20,
                    "width": 20
                },
                mask_data: bound
            }
        }];
        if (location.location_config) {
            delete location.location_config[tracking_type];

            if (location.location_config.feature_controls === undefined)
                location.location_config.feature_controls = {};

            if (location.location_config.feature_controls[tracking_type]) {
                for (let k in defaultTracking) {
                    if (location.location_config.feature_controls[tracking_type][k] === undefined) {
                        location.location_config.feature_controls[tracking_type][k] = defaultTracking[k];
                    }
                }
                if (!location.location_config.feature_controls['motion_detection']) {
                    location.location_config.feature_controls['motion_detection'] = { ...tracking[0] };
                }
                if (!location.location_config.feature_controls['vtracking']) {
                    location.location_config.feature_controls['vtracking'] = { ...tracking[1] };
                }

            } else {
                location.location_config.feature_controls['motion_detection'] = { ...tracking[0] };
                location.location_config.feature_controls['vtracking'] = { ...tracking[1] };
            }
        } else {
            location.location_config = { feature_controls: {}, config_version: 0 };
            location.location_config.feature_controls = {
                'motion_detection': {
                    enabled: true,
                    motion_frames: {
                        "mask_geometry": {
                            "height": 20,
                            "width": 20
                        },
                        mask_data: bound
                    }
                },
                'vtracking': {
                    enabled: false,
                    motion_frames: {
                        "mask_geometry": {
                            "height": 20,
                            "width": 20
                        },
                        mask_data: bound
                    }
                }
            };
        }

        let motion_frames = {
            "mask_geometry": {
                "height": 20,  // height - number of rows of boxes 
                "width": 20    // width - number of boxes in the row
            },
            mask_data: bounds
        };

        motion_frames.mask_data = LZString.compressToBase64(JSON.stringify(motion_frames.mask_data));
        location.location_config.feature_controls[tracking_type].motion_frames = motion_frames;
        if (tracking_type === 'vtracking')
            location.location_config.feature_controls.vtracking.className = ["truck", "car"];

        if (location.location_config.config_version)
            location.location_config.config_version += 1;
        else
            location.location_config.config_version = 1;

        //console.log('location', location);

        if (location.location_config.feature_controls) {
            delete location.location_config.feature_controls.hirez_mode;
        }
        var data = {
            form_input: {
                site_id: user.site_selected.site_id,
                location_id: location.location_id,
                location_config: location.location_config
            },
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        };

        CommonUtils.ajax({
            url: API.LOCATION.MODIFY,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then((res) => {
            if (res.status.code === 200) {
                user.zone_selected = location;
                for (let z of user.zones) {
                    if (z.location_id === user.zone_selected.location_id) {
                        z.location_config = user.zone_selected.location_config;
                    }
                }
                (new SessionManager()).storeCookie('user', JSON.parse(JSON.stringify(user)));
                Toastr.success('Zone tracking configuration updated successfully !');

                setModified(false);
                setZones(user.zones);
                setSelectedZone(user.zone_selected);
                let is_axis_camera = user.zone_selected.location_device_type && ['axis'].includes(user.zone_selected.location_device_type);
                // Treat uniview like legacy camera not like axis camera ...

                if (is_axis_camera)
                    publishTrackingConfig(user.zone_selected.device_id, user.zone_selected.location_config)

                if (CommonUtils.hasPath(user.zone_selected, 'location_config.special_controls.ptz_camera')) {
                    let ptz_camera = user.zone_selected.location_config.special_controls.ptz_camera;
                    if (ptz_camera && ptz_camera.home_default && ptz_camera.home_default !== "0") {

                        let preset_data = {
                            preset_id: ptz_camera.home_default,
                            location_id: user.zone_selected.location_id,
                        };

                        if (CommonUtils.hasPath(location, 'location_config.feature_controls.motion_detection'))
                            preset_data.motion_detection = location.location_config.feature_controls.motion_detection;

                        if (CommonUtils.hasPath(location, 'location_config.feature_controls.vtracking'))
                            preset_data.vtracking = location.location_config.feature_controls.vtracking;
                        savePTZPresets(preset_data).then((response) => { console.log('Preset Data status', response); })
                    }
                }

                let content = ReactDOMServer.renderToStaticMarkup(getConfigurationSummary(true))
                bootbox.alert({ message: content });
            }
        }, (err) => {
            Toastr.error('Error occurred while updating Zone tracking configuration');
        });
    }

    const savePTZPresets = async (preset) => {
        return new Promise((resolve, reject) => {
            CommonUtils.ajax({
                url: API.AXIS_CAMERA.MODIFY_PRESET,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify({
                    location_id: user.zone_selected.location_id,
                    device_id: user.zone_selected.device_id,
                    user_login: user.user_login,
                    user_token: user.user_token,
                    form_input: preset
                }),
                success: function (response) {
                    if (response.status && response.status.code === 200)
                        resolve(response.data)
                    else
                        resolve([])
                },
                error: function (xhr, status) {
                    resolve([])
                }
            });
        });
    }

    const clearCanvas = () => {
        const canvas = document.getElementById('grid_canvas');
        const ctx = canvas.getContext('2d');
        ctx.clear();
    }

    const draw = (p1, p2) => {
        const canvas = document.getElementById('grid_canvas');
        const ctx = canvas.getContext('2d');

        // set line stroke and line width
        ctx.strokeStyle = 'cyan';
        ctx.lineWidth = 2;

        // draw a red line
        ctx.beginPath();
        ctx.moveTo(p1[0][0] + 5, p1[0][1] + 7);
        ctx.lineTo(p2[0][0] + 5, p2[0][1] + 7);
        ctx.stroke();
    }

    const cancelTrackingConfig = () => {
        clearCanvas();
        let zone_selected = selectedZone;
        setZoneSelected(zone_selected);
        let bound = new Array(400).fill(0);
        bounds = bound;
        $('.optedCellHighlighted').removeClass('optedCellHighlighted');
        isModified(true);
        applyTracking();
    }

    const isModified = (reset = false) => {
        setModified(reset ? false : true);
    }

    const enableNightTimeBWMode = (event) => {
        $(event.target).toggleClass('fa-toggle-off fa-toggle-on').toggleClass('text-success text-gray');
        let enableBWMode = $(event.target).hasClass('fa-toggle-on');
        let zoneselected = JSON.parse(JSON.stringify(zone_selected));
        if (!CommonUtils.hasPath(zoneselected, 'location_config.feature_controls.irdetection.enabled'))
            CommonUtils.applyDefaults(zoneselected, 'location_config.feature_controls.irdetection.enabled',
                { location_config: { feature_controls: { irdetection: { enabled: false } } } }
            );
        zoneselected.location_config.feature_controls.irdetection.enabled = enableBWMode;
        setIsZoneModified(false);
        setZoneSelected(zoneselected);
        toggleModified("irdetection");

    }

    useEffect(() => {
        if (zone_selected !== user.zone_selected) {
            if (!isZoneModified) {
                toggleModified();
            }
        }
    }, [zone_selected]);

    const allowPublicStream = (event) => {
        $(event.target).toggleClass('fa-check-square fa-square').toggleClass('text-success text-gray');
        let zoneselected = JSON.parse(JSON.stringify(zone_selected));
        if (!CommonUtils.hasPath(zoneselected, 'location_config.feature_controls.public_stream.enabled'))
            CommonUtils.applyDefaults(zoneselected, 'location_config.feature_controls.public_stream.enabled',
                { location_config: { feature_controls: { public_stream: { enabled: false } } } }
            );
        zoneselected.location_config.feature_controls.public_stream.enabled = $(event.target).hasClass('fa-check-square');
        setZoneSelected(zoneselected);
        setIsZoneModified(false);
        toggleModified('public_stream');
    }

    const disableTracking = (event) => {
        $(event.target).toggleClass('fa-toggle-off fa-toggle-on').toggleClass('text-success text-gray');
        let trackingEnabled = $(event.target).hasClass('fa-toggle-off');
        let zoneselected = JSON.parse(JSON.stringify(zone_selected));
        let obj = zoneselected.location_config && zoneselected.location_config.feature_controls && zoneselected.location_config.feature_controls[tracking_type];
        if (obj) {
            obj.enabled = trackingEnabled;
        } else {
            CommonUtils.applyDefaults(zoneselected, 'location_config.feature_controls.' + tracking_type, { location_config: { feature_controls: { [tracking_type]: { enabled: true } } } });
            zoneselected.location_config.feature_controls[tracking_type].enabled = trackingEnabled;
        }

        setZoneSelected(zoneselected);
        setIsZoneModified(false);
        toggleModified(tracking_type);
    }

    const toggleModified = (feature) => {
        let old_tracking = zone_selected && zone_selected.location_config && zone_selected.location_config.feature_controls && zone_selected.location_config.feature_controls[tracking_type] && zone_selected.location_config.feature_controls[tracking_type].motion_frames && zone_selected.location_config.feature_controls[tracking_type].motion_frames.mask_data && JSON.parse(LZString.decompressFromBase64(zone_selected.location_config.feature_controls[tracking_type].motion_frames.mask_data));
        if (old_tracking === undefined) {
            old_tracking = new Array(400).fill(0);
        }
        let zoneselected = JSON.parse(JSON.stringify(selectedZone));

        if (feature === "irdetection" && !CommonUtils.hasPath(zoneselected, 'location_config.feature_controls.irdetection.enabled')) {
            CommonUtils.applyDefaults(zoneselected, 'location_config.feature_controls.irdetection.enabled',
                { location_config: { feature_controls: { irdetection: { enabled: false } } } }
            );
            setSelectedZone(zoneselected);
        }

        if (feature === "public_stream" && !CommonUtils.hasPath(zoneselected, 'location_config.feature_controls.public_stream.enabled')) {
            CommonUtils.applyDefaults(zoneselected, 'location_config.feature_controls.public_stream.enabled',
                { location_config: { feature_controls: { public_stream: { enabled: false } } } }
            );
            setSelectedZone(zoneselected);
        }

        if ((feature === "motion_detection") && !CommonUtils.hasPath(zoneselected, 'location_config.feature_controls.vtracking.enabled')) {
            CommonUtils.applyDefaults(zoneselected, 'location_config.feature_controls.' + feature + '.enabled',
                { location_config: { feature_controls: { [feature]: { enabled: true } } } }
            );
            setSelectedZone(zoneselected);
        }

        if ((feature === "vtracking") && !CommonUtils.hasPath(zoneselected, 'location_config.feature_controls.vtracking.enabled')) {
            CommonUtils.applyDefaults(zoneselected, 'location_config.feature_controls.' + feature + '.enabled',
                { location_config: { feature_controls: { [feature]: { enabled: false } } } }
            );
            setSelectedZone(zoneselected);
        }

        let track_condition = JSON.stringify(bounds) === JSON.stringify(old_tracking);
        let toggleOld = zoneselected && zoneselected.location_config && zoneselected.location_config.feature_controls && JSON.stringify(zoneselected.location_config.feature_controls);
        let toggleNew = zone_selected && zone_selected.location_config && zone_selected.location_config.feature_controls && JSON.stringify(zone_selected.location_config.feature_controls);
        let toggle_condition = (toggleOld === toggleNew);

        if (track_condition && toggle_condition) {
            isModified(true);
        } else {
            isModified(false);
        }
    }

    const getConfigurationSummary = (afterSave = false) => {
        let zoneSelected = zone_selected;
        return <div id='zone-config-status py-5 font-size-12'>
            <div className="text-primary title"><b>{zoneSelected.location_name}</b> configuration {afterSave ? "" : "based on above settings"}: </div>
            <ol>
                <li>
                    Object detection is turned {CommonUtils.hasPath(zoneSelected, 'location_config.feature_controls.motion_detection.enabled') ? (zoneSelected.location_config.feature_controls.motion_detection.enabled ? 'ON' : 'OFF') : 'ON'}
                </li>
                <li>
                    Vehicle Tracking is turned {CommonUtils.hasPath(zoneSelected, 'location_config.feature_controls.vtracking.enabled') ? (zoneSelected.location_config.feature_controls.vtracking.enabled ? 'ON' : 'OFF') : 'OFF'}
                </li>
                <li>
                    Black and white camera mode during night is turned {CommonUtils.hasPath(zoneSelected, 'location_config.feature_controls.irdetection.enabled') ? (zoneSelected.location_config.feature_controls.irdetection.enabled ? 'ON' : 'OFF') : 'OFF'}
                </li>
            </ol>
            Alerts will not be triggered for the people or vehicles if Object Detection is turned off. <br />
            Vehicles count will not be tallied if Vehicle Tracking is turned off.
        </div>
    }

    const modifyBounds = (idx, val) => {
        let bound = [...bounds];
        bound[idx] = val;
        bounds = bound;
        drawTrackingPolygon();
        toggleClearMaskButton();
    }

    const clearBounds = () => {
        $('.optedCellHighlighted').removeClass('optedCellHighlighted');
        let bound = new Array(400).fill(0);
        bounds = bound;
        drawTrackingPolygon();
        toggleClearMaskButton();
        toggleModified();
    }

    const drawTrackingPolygon = () => {
        if (timeout)
            clearTimeout(timeout);
        if (zone_selected && zone_selected.location_device_type === 'axis')
            setTimeOut(setTimeout(postTrackingChange, 2000));
    }

    React.useImperativeHandle(refs, () => ({
        saveTrackingConfig,
        drawTrackingPolygon
    }));

    let zoneSelected = zone_selected;
    setTimeout(() => createMesh(), 2000);

    //let currentObj = zoneSelected.location_config && zoneSelected.location_config.feature_controls && zoneSelected.location_config.feature_controls[this.state.tracking_type];
    //let isEnabled = currentObj ? currentObj.enabled : true;

    let tabContent = zoneSelected && zones.map(zone => {
        return zoneSelected.location_id === zone.location_id &&
            <div id="img_preview" key={'tracking_image_key' + zone.location_id}>
                <div id="note1" onMouseOver={() => $('#note1').hide()} onMouseOut={() => setTimeout(() => $('#note1').show(), 5000)} style={{ position: 'absolute', right: '7px', top: '7px', zIndex: 500 }}>
                    <span className="font-size-12 p-2 border-rounded" style={{ background: '#ffffffbd' }}><i className="fa fa-lg fa-info-circle"></i> {tracking_type === 'vtracking' ? 'Vehicles' : 'Persons'} entering <span style={{ border: '1px dotted red', background: 'rgba(255,0,0, 0.3)', width: '25px', height: '15px' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span> block are NOT tracked.</span>
                </div>
                <img onLoad={() => createMesh()} id="track_vehicle_image" onError={(e) => e.target.src = no_image} className="img-fluid border-light border-rounded-b" src={latest_image[zone_selected.location_id] || zone.image} alt={zone.location_name} />
                <canvas id="grid_canvas" style={{ "position": "absolute", top: "0px" }} height="518" width="914"> </canvas>
                <div id="grid" className={"optedCellContainer " + (tracking_type === 'vtracking' ? 'vtrack' : 'mtrack')} style={{ position: 'absolute', top: '0px', display: 'none' }}>
                    {
                        [...Array(400).keys()].map(k =>
                            <div id={"opted-cell-" + k} key={k} className="optedCell"
                                onMouseDown={
                                    (e) => {
                                        e.preventDefault();
                                        if (capture) {
                                            $(e.currentTarget).toggleClass('optedCellHighlighted ');
                                            if (!$(e.currentTarget).hasClass('optedCellHighlighted')) {
                                                modifyBounds($(e.currentTarget).index(), 0);
                                            } else {
                                                modifyBounds($(e.currentTarget).index(), 1);
                                            }
                                            isModified();
                                            toggleModified();
                                        }
                                    }
                                }

                                onMouseOver={(e) => {
                                    if (capture) {
                                        e.preventDefault();
                                        $(e.currentTarget).toggleClass('optedCellHighlighted');
                                        if (!$(e.currentTarget).hasClass('optedCellHighlighted')) {
                                            modifyBounds($(e.currentTarget).index(), 0);
                                        } else {
                                            modifyBounds($(e.currentTarget).index(), 1);
                                        }
                                        isModified();
                                        toggleModified();
                                    }
                                }}>
                            </div>
                        )}
                </div>


            </div >
    });

    let disable_tracking = tracking_type === 'vtracking' ? true : false;
    let enable_bw_mode = false;
    let isPublicStreamAllowed = false;

    if (zoneSelected) {
        let irdetection = CommonUtils.hasPath(zoneSelected, 'location_config.feature_controls.irdetection');
        if (irdetection && irdetection.enabled !== undefined)
            enable_bw_mode = irdetection.enabled;

        let tracking = CommonUtils.hasPath(zoneSelected, 'location_config.feature_controls.' + tracking_type);
        if (tracking && tracking.enabled !== undefined)
            disable_tracking = !tracking.enabled;


        let isPublicStream = CommonUtils.hasPath(zoneSelected, 'location_config.feature_controls.public_stream');
        if (isPublicStream && isPublicStream.enabled !== undefined)
            isPublicStreamAllowed = isPublicStream.enabled;

        // let ppe_awareness = CommonUtils.hasPath(zoneSelected, 'location_config.feature_controls.ppe_awareness');
        // if (ppe_awareness) {
        //     if(ppe_awareness !== undefined)
        //         enable_ppe_awareness = ppe_awareness.enabled;
        // }
    }
    // console.log(JSON.stringify(zoneSelected.location_config.feature_controls, null, 3));

    return (
        <React.Fragment>
            {
                saving &&
                <div className="row">
                    <div className="col-md-12"><Loading>Saving Zone Settings ...</Loading></div>
                </div>
            }
            {
                !saving && zones.length > 0 ?
                    <React.Fragment>
                        <div className="card border border-0" style={{ overflowX: "hidden" }}>
                            <div className="card-body">
                                <div className="row mb-2">
                                    <div className="col-md-6 pl-0">
                                        <label className="text-primary">Zone Settings For : <b>{zoneSelected && zoneSelected.location_name}</b></label> <br />
                                    </div>
                                    <div className="col-md-6 text-right pr-0">
                                        <button onClick={cancelTrackingConfig} className="btn btn-sm w-75 btn-light cancel-vh-settings" disabled={!modified}>Cancel</button>
                                        <button onClick={saveTrackingConfig} className="btn btn-sm w-75 btn-primary ml-2 save-vh-settings" disabled={!modified}>Save</button>
                                    </div>
                                </div>
                                <div className="row bg-lighter">
                                    <div className="col-md-9">
                                        <div className="d-flex  flex-wrap justify-content-between">
                                            <div>
                                                <div className="p-1 m-2 bg-light">
                                                    <Select
                                                        size="small"
                                                        value={tracking_type}
                                                        style={{ width: '200px', fontSize: '13px' }}
                                                        labelInValue name="tracking_type"
                                                        onChange={(x) => changeTrackingCategory(x.key)}
                                                        options={tracking_types}
                                                        dropdownMatchSelectWidth={false}
                                                        optionLabelProp={"label"}
                                                        placeholder="Tracking Type" />
                                                    <i onClick={disableTracking} className={disable_tracking === true ? "ml-1 cursor-pointer fa fa-lg fa-toggle-on text-success" : "ml-1 cursor-pointer fa fa-lg fa-toggle-off text-gray"}></i> Disable {tracking_type === 'vtracking' ? 'Vehicle Tracking' : 'Object Detection'}
                                                </div>
                                            </div>
                                            <div className="p-2">
                                                <span><i onClick={enableNightTimeBWMode} className={enable_bw_mode === true ? "cursor-pointer fa fa-lg fa-toggle-on text-success" : "cursor-pointer fa fa-lg fa-toggle-off text-gray"}></i> Enable Night Time B&amp;W Mode</span>
                                            </div>

                                            {zoneSelected.location_device_type &&
                                                <div className="p-2">
                                                    <span><i onClick={allowPublicStream} className={isPublicStreamAllowed ? "cursor-pointer fa fa-lg fa-check-square text-success" : "cursor-pointer fa fa-lg fa-checkbox far fa-square ext-gray"}></i> Enable Public Stream</span>
                                                </div>
                                            }
                                            {/* <div className="row mt-2">
                                                                <div className="col-md-12 pl-2">
                                                                    <i onClick={this.enablePPEAwareness} className={enable_ppe_awareness === false ? "fa fa-lg fa-toggle-on text-success" : "fa fa-lg fa-toggle-off text-gray"}></i> Exclude PPE Awareness
                                                                </div>
                                                            </div> */}
                                        </div>

                                        <div className="font-size-12">
                                            {getConfigurationSummary()}
                                            <div className="pt-3">
                                                <b>NOTE: </b>
                                                <i className="text-danger">Choose <b>Disable {tracking_type === 'motion_detection' ? 'Detection' : 'Tracking'}</b> feature, if you do not want to detect and show in reports/videos related to your zone/site level reports. Example: Man power daily reports.</i>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div id="clear_bounds_btn" className="col-md-12 hidden">
                                                <button className="btn btn-sm btn-primary my-2 pull-right" onClick={() => clearBounds()}>Clear Mask</button>
                                            </div>
                                        </div>
                                        <div className="row bg-white">
                                            <div className="col-md-12 px-0" onMouseLeave={() => { setCapture(false) }} >{tabContent}</div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 bg-light">
                                        <div className="row">
                                            <div className="p-1 px-3 col-md-12">
                                                Choose Zone
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <div id="zonesContainer" className="row" style={{ maxHeight: '100%', overflowY: 'scroll' }} >
                                                    {
                                                        zones.sort((x, y) => {
                                                            let a = x.location_name.trim().toLowerCase();
                                                            let b = y.location_name.trim().toLowerCase();
                                                            return ((a > b) ? 1 : (b > a) ? -1 : 0)
                                                        }).map((zone) => {
                                                            return <div key={zone.location_id} className="col-md-6 cursor-pointer zone-card p-2" onClick={() => makeZoneSelection(zone)}>
                                                                <img onError={(e) => e.target.src = no_image} className={"img-fluid border-rounded-t " + (zoneSelected && zoneSelected.location_id === zone.location_id ? "" : "border-light")} src={zone.image} alt={zone.location_name} />
                                                                <div className={"bg-lighter p-1 border-rounded-b " + (zoneSelected && zoneSelected.location_id === zone.location_id ? "bg-primary text-white" : "")}><span data-toggle="tooltip" data-placement="bottom" title={zone.location_name.length > 15 ? zone.location_name : ''}>{zone.location_name.length > 15 ? zone.location_name.substring(0, 15) + ' ...' : zone.location_name}</span></div>
                                                            </div>;
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </React.Fragment > :
                    <div className="col-md-12 text-center mt-5"> No accessible zones found ... </div>
            }
        </React.Fragment >
    );

}

export default forwardRef(VehicleTracking);